<template>
<easy-data-table
	class="data-table m-0 p-0"
	table-class-name="customize-table"
	:key="rowsPerPage"
	:headers="tableHeaders"
	:items="tableItems"
	:loading="isLoading"
	theme-color="rgb(198, 199, 200)"
	sort-by="_created"
	sort-type="desc"
	:filter-options="filterOptions"
	:rows-items="[20,40,100,200,400,1000]"
	:rows-per-page="rowsPerPage"
	rows-per-page-message="записів на сторінці"
	rows-of-page-separator-message=" з "
	:table-min-height="180"
	:table-height="height == null ? easyDataTableHeight() : height"
	alternating
	buttons-pagination
>
	<!-- If rows is empty -->
	<template #empty-message>
		{{ tableHelpTextPromt }}
	</template>

	<template #loading>
		<div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
			<span class="visually-hidden">Loading...</span>
		</div>
	</template>

	<!-- Sender item customization -->
	<template #item-sender_id="{ sender_id }">
		{{ account(sender_id).name }}<span v-if="stationId!==null">&nbsp;({{ account(sender_id).organization.title }})</span>
	</template>

	<!-- Time item customization -->
	<template #item-_created="{ _created }">
		{{ _created === undefined ? "-" : dateTimeToString(parseTimeDate(_created, true), false, false, true) }}
	</template>

	<!-- Job item customization -->
	<template #item-job="{ job, context }">
		<span v-html="taskJobDescription(job, context)"></span>
	</template>

	<!-- State item customization -->
	<template #item-state="{ state }">
		<span :class="{'text-danger': rpcTaskSchema.state.isErorrState(state), 'text-success': !rpcTaskSchema.state.isErorrState(state)}">
			{{ taskStateDescription(state) }}
		</span>
	</template>

	<!-- Complete item customization -->
	<template #item-complete="{ complete }">
		<span :class="{'fw-bold': complete}">
			{{ complete ? 'так' : "ні" }}
		</span>
	</template>

	<!-- Options item customization -->
	<template #item-options="{ destination_station_id, job, complete, state, deleting, context, _id, _etag }">
	<div class="container text-center">
	<div class="row row-cols-3">
		<div
			v-if="!complete && state === rpcTaskSchema.state.allowed.created.key"
			class="col"
		>
			<!-- Remove RPC -->
			<button
				type="button"
				class="btn btn-sm btn-outline-dark p-1 m-1"
				@click="removeRpc(_id, _etag, deleting)"
			>
				<span
					v-if="deleting"
					class="spinner-border spinner-border-sm"
					role="status"
					aria-hidden="true">
				</span>
				<svg
					v-else
					xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16"
				>
					<path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
				</svg>
			</button>
		</div>
		
		<!-- Download report -->
		<div
			v-if="complete
				&& [rpcTaskSchema.job.allowed.buildStationReport.key, rpcTaskSchema.job.allowed.buildOrganizationReport.key].includes(job)
				&& state === rpcTaskSchema.state.allowed.completeSuccess.key
			"
			class="col"
		>
			<!-- PDF -->
			<button
				type="button"
				class="btn btn-sm btn-outline-dark p-1 m-1"
				@click="downloadReportPdf(context.report_id, _reportName(destination_station_id, context, 'pdf'))"
			>
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-filetype-pdf" viewBox="0 0 16 16">
					<path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z"/>
				</svg>
			</button>
		</div>
		<div
			v-if="complete
				&& [rpcTaskSchema.job.allowed.buildStationReport.key, rpcTaskSchema.job.allowed.buildOrganizationReport.key].includes(job)
				&& state === rpcTaskSchema.state.allowed.completeSuccess.key
			"
			class="col"
		>
			<!-- XLSX -->
			<button
				type="button"
				class="btn btn-sm btn-outline-dark p-1 m-1"
				@click="downloadReportXlsx(context.report_id, _reportName(destination_station_id, context, 'xlsx'))"
			>
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-filetype-xlsx" viewBox="0 0 16 16">
					<path fill-rule="evenodd" d="M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM7.86 14.841a1.13 1.13 0 0 0 .401.823c.13.108.29.192.479.252.19.061.411.091.665.091.338 0 .624-.053.858-.158.237-.105.416-.252.54-.44a1.17 1.17 0 0 0 .187-.656c0-.224-.045-.41-.135-.56a1.002 1.002 0 0 0-.375-.357 2.028 2.028 0 0 0-.565-.21l-.621-.144a.97.97 0 0 1-.405-.176.37.37 0 0 1-.143-.299c0-.156.061-.284.184-.384.125-.101.296-.152.513-.152.143 0 .266.023.37.068a.624.624 0 0 1 .245.181.56.56 0 0 1 .12.258h.75a1.093 1.093 0 0 0-.199-.566 1.21 1.21 0 0 0-.5-.41 1.813 1.813 0 0 0-.78-.152c-.293 0-.552.05-.777.15-.224.099-.4.24-.527.421-.127.182-.19.395-.19.639 0 .201.04.376.123.524.082.149.199.27.351.367.153.095.332.167.54.213l.618.144c.207.049.36.113.462.193a.387.387 0 0 1 .153.326.512.512 0 0 1-.085.29.558.558 0 0 1-.255.193c-.111.047-.25.07-.413.07-.117 0-.224-.013-.32-.04a.837.837 0 0 1-.249-.115.578.578 0 0 1-.255-.384h-.764Zm-3.726-2.909h.893l-1.274 2.007 1.254 1.992h-.908l-.85-1.415h-.035l-.853 1.415H1.5l1.24-2.016-1.228-1.983h.931l.832 1.438h.036l.823-1.438Zm1.923 3.325h1.697v.674H5.266v-3.999h.791v3.325Zm7.636-3.325h.893l-1.274 2.007 1.254 1.992h-.908l-.85-1.415h-.035l-.853 1.415h-.861l1.24-2.016-1.228-1.983h.931l.832 1.438h.036l.823-1.438Z"/>
				</svg>
			</button>
		</div>
	</div>
	</div>
	</template>
</easy-data-table>
</template>
 

<script>
import { useAccontStore } from '@/stores/AccountStore.js'
import { useStationsStore } from '@/stores/StationsStore.js'
import { useAccounts } from '@/composables/accounts.js'
import { rpcTaskSchema, useRpcTasks, } from '@/composables/rpcTasks.js'
import { Station } from '@/models/station.js'
import {
	RESOURCE_NAMES,
	readResourceItem,
	parseTimeDate,
} from '@/api/api.js'
import {
	dateTimeToString,
	easyDataTableHeight,
	easyDataTableRowsPerPage,
} from '@/helpers.js'

export default {
	// UPDATEING_TEXT: 'Оновлення',
	inject: ['headerHeight'],

	props: {
		stationId: {
			type: String,
			require: true,
			default: null
		},

		// Update tasks awery, ms
		rpcTasksUpdateRate: {
			type: Number,
			require: false,
			default: 30000,
		},

		filterJobs: {
			type: Array,
			require: false,
			default: null,
		},

		height: {
			type: Number,
			require: false,
			default: null,
		},

		showStateColumns: {
			type: Boolean,
			require: false,
			default: true,
		},
	},

	setup(props) {
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()
		const { getAccount, } = useAccounts()
		const {
			allRpcs,
			isLoading,
			isError,
			refetch,
			deleteRpc,
		} = useRpcTasks({
			destinationStationIds: props.stationId == null ? null : [props.stationId,],
			jobs: props.filterJobs,
		})

		return {
			dateTimeToString,
			rpcTaskSchema,
			easyDataTableHeight,
			easyDataTableRowsPerPage,
			parseTimeDate,

			accountStore,
			stationsStore,

			getAccount,

			allRpcs,
			isLoading,
			isError,
			rpcRefetch: refetch,
			deleteRpc
		}
	},

	data() {
		return {
			updateInterval: null,

			// Table
			rowsPerPage: 20,
		}
	},

	mounted() {
		this.rowsPerPage = easyDataTableRowsPerPage(this.height, 41)
	},

	async created() {
		if (this.stationsStore.isNoStations) {
			// Read all stations
			await this.stationsStore.readStations()
		}
		
		this.subscribeToRpcUpdates()
	},

	methods: {
		subscribeToRpcUpdates() {
			this.unsubscribeFromRpcUpdates()

			// Updates rpc every * seconds
			this.updateInterval = setInterval(async () => {
				this.rpcRefetch()
			}, this.rpcTasksUpdateRate)
		},

		unsubscribeFromRpcUpdates() {
			if (this.updateInterval != null) {
				clearInterval(this.updateInterval)
				this.updateInterval = null
			}
		},

		account(userId) {
			return this.getAccount(userId) ?? {
				name: 'невідомо',
				organization: {
					title: ''
				}
			}
		},

		removeRpc(_id, _etag, deleting) {
			if (!deleting) {
				deleting = true
			} else {
				return
			}

			this.deleteRpc({_id, _etag,})
		},

		taskJobDescription(job, context) {
			const unitNames = {
				[Station.passportKeys.serviceUnit.self]: 'сервісний',
				[Station.passportKeys.modemUnit.self]: 'модем',
				[Station.passportKeys.breaker.self]: 'переривач',
			}
			switch(job) {
				case rpcTaskSchema.job.allowed.updateStabilizationParms.key:
					return `${rpcTaskSchema.job.findJob(job).title} ${context.parameter}=${context.value}`
				case rpcTaskSchema.job.allowed.buildStationReport.key:
					return `${rpcTaskSchema.job.findJob(job).title} `
						+ `з&nbsp;${this.formatDateString(context.from)}&nbsp;`
						+ `по&nbsp;${this.formatDateString(context.to)}`
				case rpcTaskSchema.job.allowed.buildOrganizationReport.key:
					if (context?.is_all_organizations) {
						return `звіт по всім організаціям `
							+ `з&nbsp;${this.formatDateString(context.from)}&nbsp;`
							+ `по&nbsp;${this.formatDateString(context.to)}`
					} else {
						return `${rpcTaskSchema.job.findJob(job).title} `
							+ `з&nbsp;${this.formatDateString(context.from)}&nbsp;`
							+ `по&nbsp;${this.formatDateString(context.to)}`
					}
				case rpcTaskSchema.job.allowed.setPowerCounterStartValue.key:
					return `${rpcTaskSchema.job.findJob(job).title} з ${context.prevValue} в ${context.value}`
				case rpcTaskSchema.job.allowed.setPowerUnitState.key:
					return `${context[rpcTaskSchema.context.state.key] ? 'запуск' : 'зупинка'} силового модуля станції`
				case rpcTaskSchema.job.allowed.setUnitRegisters.key:
					return rpcTaskSchema.job.findJob(job).title + ` (${unitNames[context.unit]})`
				default:
					return rpcTaskSchema.job.findJob(job)?.title
				}
		},

		taskStateDescription(state) {
			const stateObj = this.rpcTaskSchema.state.findState(state)
			return stateObj == undefined || stateObj == false
				? 'невизначено'
				: stateObj.title
		},

		formatDateString(date) {
			const parsed = parseTimeDate(date)
			try {
				return `${parsed.getDate().toString().padStart(2, '0')}`
					+`.${(parsed.getMonth()+1).toString().padStart(2, '0')}`
					+ `.${parsed.getFullYear().toString().padStart(2, '0')}`
			} catch (error) {
				return "-"
			}
		},

		async downloadReportPdf(report_id, fileName) {
			const report = await this._downloadReport(report_id)
			if (report === null) {
				return
			}

			const file = await fetch(
				`data:application/pdf;base64,${report["base64_pdf"]}`
			);
			//const file = await fetch(`data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${report}`);
			const file_blob = await file.blob();
			var a = document.createElement("a");
			a.href = window.URL.createObjectURL(file_blob);
			a.download = fileName;
			a.click();
		},

		async downloadReportXlsx(report_id, fileName) {
			//console.log("task=", task)
			const report = await this._downloadReport(report_id)
			if (report === null) {
				return
			}

			const file = await fetch(
				`data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${report["base64_xlsx"]}`
			);
			const file_blob = await file.blob();
			var a = document.createElement("a");
			a.href = window.URL.createObjectURL(file_blob);
			a.download = fileName;
			a.click();
		},

		_reportName(stationId=null, context=null, fileType) {
			// If station report
			if (stationId != null) {
				const stationName = this.station(stationId).passport.get(Station.passportKeys.name)
				const clearName = stationName.replace(/[^0-9a-zа-яА-ЯґҐєЄіІїЇ .]/gi, '')
				return clearName + `_${this.formatDateString(context.from)}-${this.formatDateString(context.to)}.${fileType}`
			// Else organization report
			} else {
				return this.account(context.writer.id).organization.title.replace(/[^0-9a-zа-яА-ЯґҐєЄіІїЇ .]/gi, '')
					+ `_${this.formatDateString(context.from)}-${this.formatDateString(context.to)}.${fileType}`
			}
		},

		async _downloadReport(report_id) {
			return await readResourceItem(
				RESOURCE_NAMES.reports,
				report_id,
				this.accountStore.userLogin,
				this.accountStore.userPassword,
			).then(response => {
				if (response === null) {
					alert("Помилка завантаження. Спробуйте повторно створити звіт.")
				}
				return response
			}).catch(error => {
				console.error(`on download report from server: "${error}".`)
				return null;	
			})
		},

		station(id) { return this.stationsStore.station(id) },
	},

	computed: {
		isForAllStations() {
			return this.stationId === null
		},

		tableHeaders() {
			const headers = []

			// If table for all stations - add first columns
			if (this.isForAllStations) {
				headers.push({ text: "Станція", value: Station.passportKeys.name, sortable: true, })
				if (this.accountStore.isPrimary) {
					headers.push({ text: "Організація", value: Station.passportKeys.orgName, sortable: true, })
				}
			}

			// Add common columns
			headers.push({ text: "Від", value: "sender_id", sortable: true, })
			headers.push({ text: "Створено", value: "_created", sortable: true, })
			headers.push({ text: "Запит", value: "job" })
			if (this.showStateColumns) {
				headers.push({ text: "Стан", value: "state", sortable: true, })
				headers.push({ text: "Виконано", value: "complete", sortable: true, })
			}

			headers.push({ text: " ", value: "options", })

			return headers
		},

		tableItems() {
			const items = []

			for (const rpc of this.allRpcs) {
				const item = structuredClone(rpc)
				const station = this.stationsStore.station(
					rpc[this.rpcTaskSchema.destinationStationId.key]
				)
		
				item[Station.passportKeys.name] = station == undefined 
					? '-'
					: station.passport.get(Station.passportKeys.name)
				
				item[Station.passportKeys.orgName] = this.account(
					item[this.rpcTaskSchema.senderId.key]
				).organization.title

				items.push(item)
			}

			return items
		},

		tableHelpTextPromt() {
			if (this.isError) {
				return 'Помилка при зчитуванні'
			}

			if (this.isLoading) {
				return 'Завантаження'
			}

			if (this.tableItems.length == 0) {
				return 'Немає даних'
			}

			return 'Невідомий стан'
		},
	},

	beforeUnmount() {
		this.unsubscribeFromRpcUpdates()
	},
}
</script>


<style src="@/assets/table.css" scoped></style>
<style scoped>
</style>